import { Components, Theme } from "@mui/material"

export const MuiAccordionDetails: Components<Theme>["MuiAccordionDetails"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRight: "1px solid",
      borderLeft: "1px solid",
      borderBottom: "1px solid",
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
      borderColor: theme.palette.primary["3"],
    }),
  },
}
